const ToolboxInfo = {
  maxInstances: {
    image_setter_block: 3,
  },
  json: {
    kind: "categoryToolbox",
    contents: [
      {
        kind: "category",
        toolboxitemid: "category",
        contents: [
          {
            kind: "block",
            type: "image_setter_block",
          },
        ],
      },
    ],
  },
};

export default ToolboxInfo;
